import { render } from "./ExtensionImages.vue?vue&type=template&id=60bde455&scoped=true&ts=true&lang=pug"
import script from "./ExtensionImages.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExtensionImages.vue?vue&type=script&lang=ts&setup=true"

import "./ExtensionImages.vue?vue&type=style&index=0&id=60bde455&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bde455"]])

export default __exports__